export const employeeReduxConstants = {
  SET_EMPLOYEES: 'SET_EMPLOYEES',
};
